import { Button, Form, Input, Space, Typography } from "antd";

import { AUTH_PLACEHOLDERS } from "@/constants";

const { Paragraph, Text } = Typography;

interface OtpVerificationFormProps {
  accountLabel?: string;
  accountValue: string;
  backText?: string;
  description: string;
  isSubmitting?: boolean;
  onBack?: () => void;
  onResend?: () => void;
  onSubmit: (otp: string) => void;
  resendCountdown?: number;
  resendDisabled?: boolean;
  submitText?: string;
}

export const OtpVerificationForm = ({
  accountLabel = "Số điện thoại",
  accountValue,
  backText,
  description,
  isSubmitting = false,
  onBack,
  onResend,
  onSubmit,
  resendCountdown = 0,
  resendDisabled = false,
  submitText = "Xác minh OTP",
}: OtpVerificationFormProps) => (
  <Form<{ otp: string }>
    key={accountValue}
    layout="vertical"
    onFinish={(values) => {
      onSubmit(values.otp);
    }}
  >
    <Form.Item label={accountLabel}>
      <Input disabled value={accountValue} />
    </Form.Item>

    <Form.Item
      label="Mã OTP"
      name="otp"
      rules={[
        { required: true, message: "Vui lòng nhập mã OTP." },
        { len: 6, message: "Mã OTP gồm 6 chữ số." },
      ]}
    >
      <Input inputMode="numeric" placeholder={AUTH_PLACEHOLDERS.otp} />
    </Form.Item>

    <Space direction="vertical" size={12} style={{ width: "100%" }}>
      <Paragraph type="secondary" style={{ marginBottom: 0 }}>
        {description}
      </Paragraph>

      <Button block htmlType="submit" loading={isSubmitting} type="primary">
        {submitText}
      </Button>

      {onResend ? (
        <Button
          block
          disabled={isSubmitting || resendDisabled || resendCountdown > 0}
          onClick={() => {
            void onResend();
          }}
        >
          {resendCountdown > 0
            ? `Gửi lại mã sau ${resendCountdown}s`
            : "Gửi lại mã"}
        </Button>
      ) : null}

      {onBack ? (
        <Button block type="link" onClick={onBack}>
          {backText ?? "Dùng số điện thoại khác"}
        </Button>
      ) : null}

      <Text type="secondary">
        Kiểm tra SMS/Zalo để lấy mã xác thực mới nhất.
      </Text>
    </Space>
  </Form>
);
